import React, { useCallback, useContext, useEffect, useState } from "react";
import ChatArea from "../ChatArea";
import AppContext from "../Context/AppContext";
import RoleNavbar from "../Navbar/Role";
import TokenNavbar from "../Navbar/Token";
import Participants from "../Participants";
import Seer from "../Role/Seer";
import Villager from "../Role/Villager";
import WereWolf from "../Role/WereWolf";
import Loading from "../Loading";

import { RoomContainer, ContentContainer } from "./style";
import Dead from "../Role/Dead";

const initialSeconds = 20;

const Room = ({ history }) => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const [loading, setLoading] = useState(true);
  const {
    username,
    chatList,
    role,
    websocket,
    members,
    isDead,
    isStarted,
    setChatList,
    setIsGameStarter,
    setMembers,
    setRole,
    setTurn,
    setIsStarted,
    setIsDead,
  } = useContext(AppContext);

  const clean = () => {
    setIsStarted(false);
    setRole("");
    setTurn("");
    setIsDead(false);
  };

  const sendMessage = useCallback(
    (message) => {
      if (websocket.readyState === websocket.OPEN) {
        let jsonMessage = JSON.stringify({ command: "msg", arg: message });
        websocket.send(jsonMessage);
        setChatList([...chatList, message]);
      }
    },
    [websocket, chatList, setChatList]
  );

  useEffect(() => {
    if (websocket === undefined || websocket === null) {
      history.push("/");
    }

    websocket.onmessage = (e) => {
      const response = JSON.parse(e.data);
      const newResponse = { ...response };
      if (response.type === "new-member") {
        const newUser = e.data.split('"')[7];
        const newUserMessage = newUser + " has joined.";
        setChatList([...chatList, newUserMessage]);
        setMembers([...members, newUser]);
      } else if (response.type === "message") {
        const from = e.data.split('"')[3];
        const msg = e.data.split('"')[7];
        const incomingMessage = from + "=>" + msg;
        setChatList([...chatList, incomingMessage]);
      } else if (response.type === "member") {
        const memberList = response.isi_member;
        setMembers([...members, ...memberList]);
      } else if (response.type === "assign-roles") {
        const assignedRole = e.data.split('"')[3];
        setRole(assignedRole);
      } else if (response.type === "turn") {
        const turn = e.data.split('"')[3];
        setTurn(turn);
        setIsStarted(true);
      } else if (response.type === "received-roles") {
        const receivedRole = "System=>" + e.data.split('"')[3];
        setChatList([...chatList, receivedRole]);
      } else if (response.type === "status") {
        const killedMessage = username + " is killed by werewolf.";
        const selfKilledMessage = "System=>You are killed by werewolf.";
        sendMessage(killedMessage);
        setChatList([...chatList, selfKilledMessage]);
        setIsDead(true);
      } else if (response.type === "vote-status") {
        const from = newResponse.from;
        const voteMessage = from + " has voted.";
        setChatList([...chatList, voteMessage]);
      } else if (response.type === "vote_decision") {
        if (response.game_status !== undefined) {
          const gameStatus = e.data.split('"')[3];
          const gameMessage = e.data.split('"')[7];
          if (gameStatus === "werewolf_lose") {
            setIsStarted(false);
            setIsGameStarter(false);
            alert("Villager win, Werewolf lose. " + gameMessage);
            clean();
          } else if (gameStatus === "werewolf_win") {
            setIsStarted(false);
            setIsGameStarter(false);
            alert("Villager lose, Werewolf win. " + gameMessage);
            clean();
          }
        }
        setSeconds(initialSeconds);
      }
    };
  });

  useEffect(() => {
    setTimeout(() => setLoading(false), 1500);
  }, []);

  const roomState = { initialSeconds, seconds, setSeconds };

  return (
    <>
      {loading === false ? (
        <RoomContainer>
          {isStarted ? <RoleNavbar {...roomState} /> : <TokenNavbar />}
          <ContentContainer>
            <Participants />
            {isDead ? (
              <Dead />
            ) : role === "werewolf" ? (
              <WereWolf />
            ) : role === "seer" ? (
              <Seer />
            ) : role === "villager" ? (
              <Villager />
            ) : (
              <ChatArea />
            )}
          </ContentContainer>
        </RoomContainer>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Room;
